import * as React from 'react';
import * as COLOURS from '../../../constants/colours';
import { createTheme, ThemeProvider, useTheme } from '@mui/material/styles';

import TextField from '@mui/material/TextField';

const customTheme = (outerTheme) =>
  createTheme({
    palette: {
      mode: outerTheme.palette.mode,
    },
    components: {
      MuiTextField: {
        styleOverrides: {
          root: {
            border: 'none',
            '& label': {
              color: '#707070',
              opacity: 0.6,
              fontFamily: 'Roboto',
              fontSize: 18,
            },

            '& label.Mui-focused': {
              color: COLOURS.soltaColor,
            },
          },
        },
      },
      MuiInputBase: {
        styleOverrides: {
          root: {
            fontSize: 18,
            fontFamily: 'Roboto',
            fontWeight: 300,
            color: '#707070',
            border: 'none',
            textAlign: 'center',
            input: {
              textAlign: 'center',
            },
            fieldset: {
              border: 'none',
              textAlign: 'center',
            },
            '&:before': {
              border: `none`,
            },
            '&:hover:not(.Mui-disabled, .Mui-error):before': {
              border: `none`,
            },
            '&.Mui-focused:after': {
              border: `none`,
            },
            '&.Mui-focused:before': {
              border: `none`,
            },
          },
        },
      },
    },
  });

export default function TipPriceTextField(props) {
  const outerTheme = useTheme();
  return (
    <ThemeProvider theme={customTheme(outerTheme)}>
      <TextField {...props} fullWidth />
    </ThemeProvider>
  );
}
